

var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));  
if(wizardInfo != null){
var url = `https://api-cdn.yotpo.com/v1/widget/L9klGXqDM8ftTtmrfrRqv0CC3aArk0IAPQQ1dJVC/products/${wizardInfo.setting_variant_id}/reviews.json`
fetch(url)
        .then(response => response.json())
        .then(data => {
            productImages = data;
          console.log(productImages.response.bottomline);
          if(productImages.response.bottomline.total_reviews > 0){
            if(productImages.response.bottomline.average_score > 0 && productImages.response.bottomline.average_score <1){
             $('a.ir218-stars.ir218-stars-small').css('background-position','left -12px');
            }else if(productImages.response.bottomline.average_score == 1){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -26px');
            }
            else if(productImages.response.bottomline.average_score > 1 && productImages.response.bottomline.average_score <2){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -39px');
            }
            else if(productImages.response.bottomline.average_score  == 2 ){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -52px');
            }
            else if(productImages.response.bottomline.average_score > 2 && productImages.response.bottomline.average_score < 3){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -66px');
            }
            else if(productImages.response.bottomline.average_score = 3){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -78px');
            }
            else if(productImages.response.bottomline.average_score > 3 && productImages.response.bottomline.average_score < 4){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -91px');
            }
            else if(productImages.response.bottomline.average_score = 4){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -103px');
            }
            else if(productImages.response.bottomline.average_score > 4 && productImages.response.bottomline.average_score < 5){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -117px');
            }
            else if(productImages.response.bottomline.average_score = 5){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -129px');
            }
  $('.reviews-badgets .ir218-write-read a').html(`(${productImages.response.bottomline.total_reviews})`)
          }else{
            $('.reviews-badgets').hide();
          }
        })
}
function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}

// Calculate Greatest Common Divisor
function gcd(a, b) {
    if (b === 0) {
      return a;
    }
    return gcd(b, a % b);
  }
  
  // Convert a decimal number to a simplified fraction
  function decimalToFraction(decimal) {
    const integerPart = Math.floor(decimal);
    let fractionPart = decimal - integerPart;
  
    // Define the precision for converting the fraction part
    const precision = 1000000;
    
    let numerator = Math.round(fractionPart * precision);
    let denominator = precision;
  
    // Simplify the fraction
    const commonDivisor = gcd(numerator, denominator);
    numerator /= commonDivisor;
    denominator /= commonDivisor;
  
    // Construct the output string
    let output = '';
    if (integerPart !== 0) {
      output += integerPart;
    }
  
    if (numerator !== 0) {
      if (integerPart !== 0) {
        output += ' ';
      }
      output += `${numerator}/${denominator}`;
    }
  
    if (integerPart === 0 && numerator === 0) {
      output = '0';
    }
  
    return output;
  }

async function createProductFinish(){
let infoRing = JSON.parse(localStorage.getItem('wizardInfo_gemstone')); 
  if(infoRing != null){
  var p_handle = infoRing.gemstone_handle
  var gemstone_data = await getdiamond_img(wizardInfo.gemstone_id);
  var gemstone_matchingnum = gemstone_data.MatchingNum.toLowerCase().replaceAll(' ','-');
  var gemstone_measurements = gemstone_data.Measurements.replaceAll('.00','').replaceAll(' ','');
  $.ajax({
    url: `/products/${p_handle}?view=inventory`,
    success: function(html){
     var product_inventory = parseInt($(html).find('.product_inventory_inner').text());
     var total_cart_quantity = parseInt($(html).find('.total_cart_quantity').text());
     var track_of = $(html).find('.product_track_of').length;
     console.log("<<<<track_of");
     console.log(track_of);
     console.log("<<<<gemstone_measurements");
     console.log(gemstone_measurements);
     console.log("<<<<gemstone_matchingnum");
     console.log(gemstone_matchingnum);
     if(product_inventory > total_cart_quantity || track_of == 1){
       if(gemstone_measurements != undefined && gemstone_measurements != '' && gemstone_matchingnum != undefined && gemstone_matchingnum != ''){
          fetch(window.API_URL+`diamonds/getSinglegemstoneCarat/weight/${gemstone_matchingnum}&${gemstone_measurements}`, {
          method: 'GET',
          headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
          }).then(res => res.json())
          .then(response => {
          console.log("<<<response");
          console.log(response);
          console.log(response.gemstone_carat);
          if($('.accent_stone_val[data-shape="'+infoRing.setting_selected_shape+'"][data-carat="'+response.gemstone_carat+'"]').length >0 && response.gemstone_carat != undefined){
           var accent_stone = $('.accent_stone_val[data-shape="'+infoRing.setting_selected_shape+'"][data-carat="'+response.gemstone_carat+'"]').html();
          }else{
            var accent_stone = $('.accent_stone_val[data-shape="'+infoRing.setting_selected_shape+'"][data-carat="1"]').html();
          }
          console.log("<<<<<product inventory");
        console.log(product_inventory); 
           addCart(html,product_inventory,gemstone_data,accent_stone)
          });
       }else{
        var accent_stone = $('.accent_stone_val[data-shape="'+infoRing.setting_selected_shape+'"][data-carat="1"]').html();
        
        addCart(html,product_inventory,gemstone_data,accent_stone)
       }
     }else{
      $('#selected_value_error').html('This Gemstone is not available please Choose another gemstone ').show();
     }
    }
  });
  }
}

function addCart(res,product_inventory,gemstone_data,accent_stone){
  if(accent_stone != undefined){
    accent_stone = accent_stone
  }else{
    accent_stone ='';
  }
  let currentCurrency = Shopify.currency.active;
  let currentCurrencySymbol = $('body').attr('data-currency');
  let currentRate = window.Shopify.currency.rate;
  let infoRing = JSON.parse(localStorage.getItem('wizardInfo_gemstone')); 
  let selectSize = document.getElementById('select-size');
  let selectedSize =  selectSize.options[selectSize.selectedIndex].value; 
  let deliver_date = $('#deliverydate').text();
   product_inventory = product_inventory;
  let selectImage = infoRing.setting_image_url;
  let selectProductname = infoRing.setting_product_handle;
  let carat_list =localStorage.getItem('product_carat_value1');
  let selectVariantPrice= infoRing.setting_variant_price;
  let stoneImage = gemstone_data.Image1;
  let stonePrice = gemstone_data.Price2Total;
  let stoneShape = gemstone_data.Shape;
  let allowedSize = $(res).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('data-ring-sizes');
  let stone_pd_handle = infoRing.gemstone_handle;
  let items = [];
  let gemstone_deliver_date = $('#deliverydate').text();
  localStorage.setItem('wizardInfo_gemstone',JSON.stringify(infoRing));
  let wizardInfo = JSON.stringify(localStorage.getItem('wizardInfo_gemstone'));
  let wizardStart = localStorage.getItem('wizardStart');
  var rendom_no = (Math.random().toString(36)+'00000000000000000').slice(2, 10+2);
  console.log("<<<<<<<res");
  //$(res).find('.product_transprancy_pricing').attr('data-id')
  console.log(res);
    if($(res).find('.product_transprancy_pricing').attr('data-id') != null && infoRing.setting_variant_id != '' && infoRing.setting_variant_id != 0 ){
    items.push({'id':  infoRing.gemstone_variant_id,'quantity': 1,properties: {'_ring_product_id':infoRing.setting_variant_id,'_ring_product_title':infoRing.gemstone_handle,'_gemstone_with_ring':true,'_rendom_no':rendom_no }});
   }
  if(infoRing.setting_variant_id != null && infoRing.setting_variant_id != ''){
     items.push({'id': infoRing.setting_variant_id ,'quantity': 1,properties: {'Size': selectedSize,'_accent_stone_detail':accent_stone,'_wizardInfo': wizardInfo, '_wizardStart': wizardStart, '_allowedSize':allowedSize, '_pid': infoRing.setting_product_id, '_selectVariantPrice':selectVariantPrice, '_image': selectImage, '_pname': selectProductname,'_deliver_date': deliver_date, '_stoneImage':stoneImage,'_stonePrice':stonePrice, '_stoneShape':stoneShape,'_ring_with_gemstone':true,'_stone_name':gemstone_data.Title,'_stone_color':gemstone_data.ColorHue,'_rendom_no':rendom_no,'_stone_pd_handle':stone_pd_handle,'_stone_inventory':product_inventory,'_gemstone_deliver_date':gemstone_deliver_date  }});
  }

  console.log(items);
   let body = {
        "items": items
        }
  console.log("<<<<items");
   console.log(body);    
  fetch((window.Shopify.routes.root +"cart/add.js"), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)       
    }).then(response => {
        let url = window.Shopify.routes.root+"cart";
        var gemstone_complete_step = localStorage.getItem("gemstone_complete_step");
        var diamond_step = localStorage.getItem("diamond_page_step");
        if(gemstone_complete_step != null){
          window.localStorage.removeItem('gemstone_complete_step');
        }
        if(diamond_step != null){
        window.localStorage.removeItem('diamond_page_step');
        }
       localStorage.setItem('Product_Added',true);
         window.location.href = url;  
        })
        .catch(error => console.error('Error:', error)); 
}
// updated btn change av007
$("#select-size").on("change", function(){
    let selectedVal = $(this).val();  
    $("#select-size option[value='default']").val(selectedVal); 
    console.log("Captured value:", selectedVal);
  });
//updated btn change
function bindEventsAddCart(){
  let btnText = null;
 
   document.getElementById('diamond-with-setting').addEventListener('click', event => {
    var default_selected_val = $('#select-size').find(":selected").val();
    if(default_selected_val == 'default'){
    $('#selected_value_error').show();
    }else{
     createProductFinish();
     }
    });
  
}
$(document).on('click','#diamond-img2 span._360_icons.gemstone',function(){
    if($('#diamond-img2 ._360_main_container .Magic360').find('canvas').length > 0 ){
    Magic360.stop(`spin-1`); 
    $(this).parents('#diamond-img2').find('.poster_image').show();
    $(this).parents('#diamond-img2').find('.preview').hide();
    $(this).parents('.gemstone_image_wrapper').find('.wrapper_inner .preview').show();
    var spiner =  $(this).parents('').find('._360_main_container .Magic360').attr('id');
   
    }else{
       $(this).parents('#diamond-img2').find('.poster_image').hide();
    $(this).parents('#diamond-img2').find('.preview').show();
    $(this).parents('.gemstone_image_wrapper').find('.wrapper_inner .preview').hide();
    var spiner =  $(this).parents('').find('._360_main_container .Magic360').attr('id');
    Magic360.start(`spin-1`); 
    }
  
})
$(document).on('click','.diamond-img2 span._360_icons.gemstone',function(){
  if($('.diamond-img2 ._360_main_container .Magic360').find('canvas').length > 0 ){
    Magic360.stop(`spin-mob-1`); 
    $(this).parents('.diamond-img2 ').find('.poster_image').show();
    $(this).parents('.diamond-img2 ').find('.preview').hide();
    $(this).parents('.gemstone_image_wrapper').find('.wrapper_inner .preview').show();
    var spiner =  $(this).parents('').find('._360_main_container .Magic360').attr('id');
   
    }else{
       $(this).parents('.diamond-img2 ').find('.poster_image').hide();
    $(this).parents('.diamond-img2 ').find('.preview').show();
    $(this).parents('.gemstone_image_wrapper').find('.wrapper_inner .preview').hide();
    var spiner =  $(this).parents('').find('._360_main_container .Magic360').attr('id');
    Magic360.start(`spin-mob-1`); 
    }
})
function bindEventsSelectSize(sizeDefault){
    let button = document.getElementById('button-select'); 
    document.querySelectorAll('#select-size > .select-size-1').forEach((opciones)=>{
        opciones.addEventListener('click',(e)=>{
           
            let valor =e.currentTarget.getElementsByTagName('h2')[0].innerHTML; 
            let imgs = loadUrlImages();            
            let img;
            let imgsFilter=[];
            let imgNum = 1;
        });
   });  
}

async function bindEvents() {  
    bindEventsAddCart();
let ring_band_product = JSON.parse(localStorage.getItem('ring_band_product'));
var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
if(ring_band_product != null && wizardInfo != null){
  wizardInfo_gemstone.setting_product_handle = ring_band_product.band_and_ring_handle;
  wizardInfo_gemstone.setting_product_name = ring_band_product.band_and_ring_title;
  localStorage.setItem('wizardInfo_gemstone',JSON.stringify(wizardInfo_gemstone));
}
if(wizardInfo_gemstone != null){
   var gemstone_data = await getdiamond_img(wizardInfo_gemstone.gemstone_id); 
  var product_data = await getProductdata(wizardInfo.setting_product_handle);
  if(wizardInfo_gemstone.gemstone_id == null){
  localStorage.removeItem("wizardStart")
  window.location.href=window.location.origin;
  }
   var diamond_id = wizardInfo_gemstone.gemstone_id;
   var handle = wizardInfo_gemstone.setting_product_handle;
   getProductImage(handle,purpose);
   var img_url =wizardInfo_gemstone.setting_image_url;
   var pd_sku =$(product_data).find('.product_transprancy_pricing[data-id="'+wizardInfo.setting_variant_id+'"]').attr('v_sku');
   if(ring_band_product != null ){
   pd_sku = ring_band_product.band_and_ring_sku
   }
   var p_id =$(product_data).find('.product_transprancy_pricing[data-id="'+wizardInfo.setting_variant_id+'"]').attr('p_id');
   var ston_shap =wizardInfo_gemstone.setting_selected_shape.toLocaleLowerCase();
  var stone_shape_360 =gemstone_data.Shape.toLocaleLowerCase();
   var carat_val_deci = 0;
   var carat_val_2 =1/2;
   var carat_val_3 = '1/2';
   var carat_val_4;
   var carat_val ;
   var setting_selected_metal=wizardInfo_gemstone.setting_selected_metal.toLowerCase().replace(/[^a-z0-9]+/g, '').replace(/-$/, '').replace(/^-/, '');
   var gemstone_typee = wizardInfo_gemstone.gemstone_type.toLowerCase().replace(/ /g,"-");
   var gemstone_shapee = wizardInfo_gemstone.gemstone_shape.toLowerCase().replace(/ /g,"-");
   var gemstone_idd = wizardInfo_gemstone.gemstone_id.toLowerCase().replace(/ /g,"-");
   var gemstone_namee = gemstone_data.Title.replace(/\s+/g, '-').replaceAll('.', '-').toLowerCase();
   var setting_video_count=localStorage.getItem('setting_video_count');
   var product_carat_value1 = localStorage.getItem('product_carat_value1');
   if(product_carat_value1 == undefined || product_carat_value1 == null  ){
    product_carat_value1 =  $('.catar_uploded_image').attr('data-obj');
   }                
    var carat_size =wizardInfo_gemstone.stone_carat;
    var flag =0;
    var flag1 = 0;
  if(product_carat_value1 != null){
    var carart_val = product_carat_value1
    var carat_val1 = carart_val.split(",");
    $(carat_val1).each(function(index,e){
    carat_val_2=e.split("|")[1];
    carat_val_2= _.replace(carat_val_2, "/","-");
          var carat_val_deci=parseFloat(this.split("|")[0]);
          if(carat_val_deci != ''){
          if(carat_val_deci == carat_size){
             change_url = 'false';
          }
            if(carat_val_deci <= carat_size && flag1 == 0){
              carat_val_3 = carat_val_2;
              flag =1;
            }else if(carat_val_deci >= carat_size && flag == 0){
              flag1 = 1
              carat_val_3 = carat_val_2;
            }
          }
          });
          var sku = `dyor_setting_${pd_sku}`
         
          if(carat_val_3.indexOf('-') > -1){
          if(carat_val_3.length >3){
            var position = 1
            carat_val_4 = [carat_val_3.slice(0, position), carat_val_3.slice(position)].join(' ');
            carat_val=carat_val_4.replace('-','/');
            }else{
            carat_val=carat_val_3.replace('-','/');
           }
           }else{
            carat_val = carat_val_3;
         }
           var aws_img =false;
           var new_360url_check = `https://dsv7iunirnrax.cloudfront.net/360/${p_id}/${pd_sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-4/frame01.png`
           var new_360_url =  `${p_id}/${pd_sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-`
           var new_url = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}`
           var new_url_check = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-1.jpg`
          var new_url_src = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}_${gemstone_idd}`
          var new_url_check_src = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}_${gemstone_idd}-1.jpg`
          var new_url_src1 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}`
          var new_url_check_src1 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}-1.jpg`
        
        var new_url_check_2 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-2.jpg`
        var new_url_check_gem_2 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}_${gemstone_idd}-2.jpg`
        var new_url_check_src_2 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}-2.jpg`
        checkImageExists(new_url_check_gem_2, function(exists) {
                 if (exists) {
                   $(`#grid-img-diamond #diamond-img4 ,div#carouselExampleIndicators .carousel-inner .diamond-img4`).html(`<img src=${new_url_check_gem_2} alt="">`);
                   
             } else {
                 checkImageExists(new_url_check_src_2, function(exists) {
                     if (exists) {
                  $(`#grid-img-diamond #diamond-img4 ,div#carouselExampleIndicators .carousel-inner .diamond-img4`).html(`<img src=${new_url_check_src_2} alt="">`);
                       
                     } else {
                      checkImageExists(new_url_check_2, function(exists) {
                             if (exists) {
                   $(`#grid-img-diamond #diamond-img4 ,div#carouselExampleIndicators .carousel-inner .diamond-img4`).html(`<img src=${new_url_check_2} alt="">`);         
                             }
                         });
                     }
                 });
             }
          });


        var new_url_check_3 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-3.jpg`
        var new_url_check_gem_3 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}_${gemstone_idd}-3.jpg`
        var new_url_check_src_3 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}-3.jpg`
        checkImageExists(new_url_check_gem_3, function(exists) {
                 if (exists) {
                   $(`#grid-img-diamond #diamond-img5 ,div#carouselExampleIndicators .carousel-inner .diamond-img5`).html(`<img src=${new_url_check_gem_3} alt="">`);
                   
             } else {
                 checkImageExists(new_url_check_src_3, function(exists) {
                     if (exists) {
                  $(`#grid-img-diamond #diamond-img5 ,div#carouselExampleIndicators .carousel-inner .diamond-img5`).html(`<img src=${new_url_check_src_3} alt="">`);
                       
                     } else {
                      checkImageExists(new_url_check_3, function(exists) {
                             if (exists) {
                   $(`#grid-img-diamond #diamond-img5 ,div#carouselExampleIndicators .carousel-inner .diamond-img5`).html(`<img src=${new_url_check_3} alt="">`);         
                             }
                         });
                     }
                 });
             }
          });

        var new_url_check_4 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-5.jpg`
        var new_url_check_gem_4 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}_${gemstone_idd}-5.jpg`
        var new_url_check_src_4 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}-5.jpg`
        checkImageExists(new_url_check_gem_4, function(exists) {
                 if (exists) {
                   $(`#grid-img-diamond #diamond-img7 ,div#carouselExampleIndicators .carousel-inner .diamond-img7`).html(`<img src=${new_url_check_gem_4} alt="">`);
                   
             } else {
                 checkImageExists(new_url_check_src_4, function(exists) {
                     if (exists) {
                  $(`#grid-img-diamond #diamond-img7 ,div#carouselExampleIndicators .carousel-inner .diamond-img7`).html(`<img src=${new_url_check_src_4} alt="">`);
                       
                     } else {
                      checkImageExists(new_url_check_4, function(exists) {
                             if (exists) {
                   $(`#grid-img-diamond #diamond-img7 ,div#carouselExampleIndicators .carousel-inner .diamond-img7`).html(`<img src=${new_url_check_4} alt="">`);         
                             }
                         });
                     }
                 });
             }
          });
    
        var new_url_check_5 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-6.jpg`
        var new_url_check_gem_5 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}_${gemstone_idd}-6.jpg`
        var new_url_check_src_5 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}-6.jpg`
        checkImageExists(new_url_check_gem_5, function(exists) {
                 if (exists) {
                   $(`#grid-img-diamond #diamond-img8 ,div#carouselExampleIndicators .carousel-inner .diamond-img8`).html(`<img src=${new_url_check_gem_5} alt="">`);
                   
             } else {
                 checkImageExists(new_url_check_src_5, function(exists) {
                     if (exists) {
                  $(`#grid-img-diamond #diamond-img8 ,div#carouselExampleIndicators .carousel-inner .diamond-img8`).html(`<img src=${new_url_check_src_5} alt="">`);
                       
                     } else {
                      checkImageExists(new_url_check_5, function(exists) {
                             if (exists) {
                   $(`#grid-img-diamond #diamond-img8 ,div#carouselExampleIndicators .carousel-inner .diamond-img8`).html(`<img src=${new_url_check_5} alt="">`);         
                             }
                         });
                     }
                 });
             }
          });

          var new_url_check_6 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${gemstone_data.Shape.toLocaleLowerCase()}_1_${setting_selected_metal}-6.jpg`
        var new_url_check_gem_6 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}_${gemstone_idd}-6.jpg`
        var new_url_check_src_6 = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${gemstone_typee}/${gemstone_shapee}_${setting_selected_metal}-6.jpg`
        checkImageExists(new_url_check_gem_6, function(exists) {
                 if (exists) {
                   $(`#grid-img-diamond #diamond-img9 ,div#carouselExampleIndicators .carousel-inner .diamond-img9`).html(`<img src=${new_url_check_gem_6} alt="">`);
                   
             } else {
                 checkImageExists(new_url_check_src_6, function(exists) {
                     if (exists) {
                  $(`#grid-img-diamond #diamond-img9 ,div#carouselExampleIndicators .carousel-inner .diamond-img9`).html(`<img src=${new_url_check_src_6} alt="">`);
                       
                     } else {
                      checkImageExists(new_url_check_6, function(exists) {
                             if (exists) {
                   $(`#grid-img-diamond #diamond-img9 ,div#carouselExampleIndicators .carousel-inner .diamond-img9`).html(`<img src=${new_url_check_6} alt="">`);         
                             }
                         });
                     }
                 });
             }
          });

    
        
         checkImageExists(new_url_check_src, function(exists) {
             var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
             if (exists) {
                 var purpose = 'get_aws_img'
                 if (wizardInfo_gemstone != null) {
                     var handle = wizardInfo_gemstone.setting_product_handle;
                 }
                 getProductImage(handle, purpose, gemstone_data, new_url_src, p_id, new_360_url, new_url);
             } else {
                 checkImageExists(new_url_check_src1, function(exists) {
                     if (exists) {
                         var purpose = 'get_aws_img'
                         if (wizardInfo_gemstone != null) {
                             var handle = wizardInfo_gemstone.setting_product_handle;
                         }
                         getProductImage(handle, purpose, gemstone_data, new_url_src1, p_id, new_360_url, new_url);
                     } else {
                         checkImageExists(new_url_check, function(exists) {
                             var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
                             if (exists) {
                                 var purpose = 'get_aws_img'
                                 if (wizardInfo_gemstone != null) {
                                     var handle = wizardInfo_gemstone.setting_product_handle;
                                 }
                                 getProductImage(handle, purpose, gemstone_data, new_url, p_id, new_360_url, new_url);
                             } else {
                                 if (wizardInfo_gemstone != null || wizardInfo_gemstone != undefined) {
                                     var handle = wizardInfo_gemstone.setting_product_handle;
                                     var purpose = 'get_img'
                                     getProductImage(handle, purpose, gemstone_data);
                                 }
                             }
                         })
                     }
                 })
             }
         })                                                                                         
         checkImageExists(new_360url_check, function(exists) {
           var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
           var handle = wizardInfo_gemstone.setting_product_handle;
           
           if (exists) {
              var purpose_video = 'get_aws_video'
             getProductImage(handle,purpose_video,gemstone_data,new_360url_check,p_id,new_360url_check,gemstone_data);
           }else{
         
            var purpose_video= 'get_video'
            getProductImage(handle,purpose_video);
            
            }
         })



    
         



    
          }else{
          
          var wizardInfo_gemstone = JSON.parse(localStorage.getItem("wizardInfo_gemstone"));
          if(wizardInfo_gemstone != null || wizardInfo_gemstone != undefined){
          var handle = wizardInfo_gemstone.setting_product_handle;
          var purpose= 'get_img'
          getProductImage(handle,purpose,gemstone_data)
          }
          }
          }else{
          localStorage.removeItem("wizardStart")
          window.location.href=window.location.origin;
          }
          }
          async function order_detail(){
          var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
          var res = await getProductdata(wizardInfo.setting_product_handle);
          var resgemstone = await get_gemstone_value();
          var gemstone_price = await get_gemstone_prices();
          if($(res).find('.pricing_tab_content .pricing_data').attr('data-title') != '' && $(res).find('.pricing_tab_content .pricing_data').attr('data-content') != '' && $(res).find('.pricing_tab_content .pricing_data').attr('data-content') != '' ){
      $('.complete_gemstone_order_tabs .pricing_title').text($(res).find('.pricing_tab_content .pricing_data').attr('data-title'));
      $('.complete_gemstone_order_tabs .pricing_description').html(`<p>${$(res).find('.pricing_tab_content .pricing_data').attr('data-content')}</p>`);
      $('.complete_gemstone_order_tabs .creative_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-creative-tooltip'));
      $('.complete_gemstone_order_tabs .components_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-component-tootip'));
      $('.complete_gemstone_order_tabs .crafting_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-crafing'));
      $('.complete_gemstone_order_tabs .packaging_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-packing-tooltip'));
      $('.complete_gemstone_order_tabs .duties_freight_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-duties-tooltip'));
      $('.complete_gemstone_order_tabs .credit_card_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-credit-tooltip'));
      $('.complete_gemstone_order_tabs .total_selling_cost_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-total-salling-cost'));
      $('.complete_gemstone_order_tabs .retail_price_main_tooltip').text($(res).find('.pricing_tab_content .pricing_data').attr('data-retail-tooltip'));
      $('.complete_gemstone_order_tabs #tab-4 .fst_tab_cnt_lft').html(`<h2>${$(res).find('.sourcing-data').attr('data-our-process-title')}</h2><div>${$(res).find('.sourcing-data').attr('data-our-process-content')}</div>`).show();
      $('#tab-4 .box-wrap').html($(res).find('.sourcing-bottom_data .box-wrap').html());
      $('#tab-4 .progressive_bar_tabs').html($(res).find('.progressive_bar_tabs[data-title="42100730396808"]').html());
      $('#tab-3').html($(res).find('#tab-3').html())
      $('#tab-2').html($(res).find('#tab-2').html());
      var deliver_date = $('#deliverydate').text();
      $('#est_ship').text(deliver_date);
       if($(res).find('.product_pricing_component').length >0){
      $('a#pricing_tab').hide();
      $('div#tab-1').hide();     
      var creativity_cost = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-creativity-cost');
      var component_cost = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-component-price');
      var crafting_cost = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-crafting-cost');
      var packaging_cost = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-packaging-cost');
      var duties_cost = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-duties-freight-cost');
      var retail_cost = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-retail-price');
      var data_component_per_val = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-component-pre_val');
      var data_component_wet_val = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-component-wet_val');
      var data_crafting_per_val = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-crafting-pre_val');
      var data_crafting_wet_val = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-crafting-wet_val');
      var data_packging_per_val = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-packging-pre_val');
      var data_packging_wet_val = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-packging-wet_val');
      var product_variant_price = $(res).find('.product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-price');
         console.log(creativity_cost);
      var total_sell_price = parseFloat(product_variant_price.replace(',',''));
      var credit_price = ((parseFloat(product_variant_price.replace(',',''))*2.9)/100)+0.3;
      if(resgemstone != 'Not Found'){
        if(resgemstone.duties_freight_handling != undefined && resgemstone.duties_freight_handling != ''){
        duties_cost = parseFloat(resgemstone.duties_freight_handling)+parseFloat(duties_cost);
        }
        if(resgemstone.packaging != undefined && resgemstone.packaging != ''){
        packaging_cost = parseFloat(resgemstone.packaging)+parseFloat(packaging_cost);
        }
        if(gemstone_price.CostTotal != undefined && gemstone_price.CostTotal != ''){
        component_cost = parseFloat(gemstone_price.CostTotal)+parseFloat(component_cost);
        }
        if(resgemstone.source_components_percentage != undefined && resgemstone.source_components_percentage != ''){
        data_component_per_val = parseInt(data_component_per_val) + parseInt(resgemstone.source_components_percentage)
        }
        if(resgemstone.source_components_weightage != undefined && resgemstone.source_components_weightage != ''){
        data_component_wet_val = parseInt(data_component_wet_val) + parseInt(resgemstone.source_components_weightage)
        }
        if(resgemstone.source_crafting_cost_percentage != undefined && resgemstone.source_crafting_cost_percentage != ''){
        data_crafting_per_val = parseInt(data_crafting_per_val) + parseInt(resgemstone.source_crafting_cost_percentage)
        }
        if(resgemstone.source_crafting_cost_weightage != undefined && resgemstone.source_crafting_cost_weightage != ''){
        data_crafting_wet_val = parseInt(data_crafting_wet_val) + parseInt(resgemstone.source_crafting_cost_weightage)
        }
         if(resgemstone.source_packaging_percentage != undefined && resgemstone.source_packaging_percentage != ''){
        data_packging_per_val = parseInt(data_packging_per_val) + parseInt(resgemstone.source_packaging_percentage)
         }
        if(resgemstone.source_packaging_weightage != undefined && resgemstone.source_packaging_weightage != ''){
        data_packging_wet_val = parseInt(data_packging_wet_val) + parseInt(resgemstone.source_packaging_weightage)
        }
        total_sell_price = (total_sell_price + parseFloat(gemstone_price.Price2Total)).toFixed(2)
        retail_cost = (parseFloat(gemstone_price.MSRPTotal)+parseFloat(retail_cost)).toFixed(2);
        if(resgemstone.packaging != undefined && resgemstone.duties_freight_handling != undefined ){
        credit_price = ((parseFloat(resgemstone.duties_freight_handling)+parseFloat(resgemstone.packaging)+parseFloat(gemstone_price.CostTotal)*2.9)/100)+0.3+credit_price
        }
       }
       }
        if(data_component_per_val >100){
          $('#tab-4 .tablinks.components .Prg_tab_bar_inner_color').css('width','100%')
        }else{
          $('#tab-4 .tablinks.components .Prg_tab_bar_inner_color').css('width',data_component_per_val+'%')
        }
        if(data_crafting_per_val >100){
          $('#tab-4 .tablinks.crafting-cost .Prg_tab_bar_inner_color').css('width','100%')
        }else{
          $('#tab-4 .tablinks.crafting-cost .Prg_tab_bar_inner_color').css('width',data_crafting_per_val+'%')
        }
        if(data_packging_per_val >100){
          $('#tab-4 .tablinks.packaging .Prg_tab_bar_inner_color').css('width','100%')
        }else{
          $('#tab-4 .tablinks.packaging .Prg_tab_bar_inner_color').css('width',data_packging_per_val+'%')
        }
       $('#tab-4 .tablinks.components .prg_bar_total_percent').text(data_component_per_val+'%');
       $('#tab-4 .tablinks.crafting-cost .prg_bar_total_percent').text(data_crafting_per_val+'%');
       $('#tab-4 .tablinks.packaging .prg_bar_total_percent').text(data_packging_per_val+'%');
       var Overall_component = (data_component_per_val*data_component_wet_val)/100;
       var Overall_crafting = (data_crafting_per_val*data_crafting_wet_val)/100;
       var Overall_packging = (data_packging_per_val*data_packging_wet_val)/100;
       $('#tab-4 .tabcontent.components .tab_leftbottom_cnt_jtpl h3').text(`${Overall_component}% Overall Traceability`);
       $('#tab-4 .tabcontent.crafting-cost .tab_leftbottom_cnt_jtpl h3').text(`${Overall_crafting}% Overall Traceability`);
       $('#tab-4 .tabcontent.packaging .tab_leftbottom_cnt_jtpl h3').text(`${Overall_packging}% Overall Traceability`);
       var total_price = parseFloat(creativity_cost)+parseFloat(component_cost)+parseFloat(crafting_cost)+parseFloat(packaging_cost)+parseFloat(duties_cost)+parseFloat(credit_price);
       var main_price_bar = total_sell_price-total_price
        if(main_price_bar > 1050){
        var main_price_bar = (total_sell_price - total_price)/8;  
        } 
        else  if(main_price_bar > 800){
        var main_price_bar = (total_sell_price - total_price)/7;  
        } 
        else if(main_price_bar > 500){
        var main_price_bar = (total_sell_price - total_price)/5;
        }else if(main_price_bar > 200 ){
        var main_price_bar = (total_sell_price - total_price)/4;
        }else if(main_price_bar > 100 ){
        var main_price_bar = (total_sell_price - total_price)/2;
        }
        else{
        var main_price_bar = (total_sell_price - total_price)
        }
        $('.complete_gemstone_order_tabs .left-side-sct .inner_progress .main-progress').css('height',`${main_price_bar}px`);
        var retail_price_bar = retail_cost - total_price;
        if(retail_price_bar > 1050){
        var retail_price_bar = (retail_cost - total_price)/8;
        }
        else if(retail_price_bar > 800){
        var retail_price_bar = (retail_cost - total_price)/7;
        }
        else if(retail_price_bar > 500){
        var retail_price_bar = (retail_cost - total_price)/5;
        }else if(retail_price_bar > 200){
        var retail_price_bar = (retail_cost - total_price)/4;
        }else if(main_price_bar > 100 ){
        var main_price_bar = (total_sell_price - total_price)/2;
        }else{
        var retail_price_bar = (retail_cost - total_price)
        }
        $('.complete_gemstone_order_tabs .right-side-sct .inner_progress .main-progress').css('height',`${retail_price_bar}px`);
        if(gemstone_price != 'Not Found'){
        if(gemstone_price.Lab == "GIA"){
        $('#tab-3 .order_include .accordion-item-body-content p:first').prepend(`<p>GIA Certificate included</p>`)
        }
        if(gemstone_price.FullDescription != '' && gemstone_price.FullDescription != null){
        if(gemstone_price.FullDescription.split('<!-- Cutting Factory  -->')[1] != undefined){
         var cutfactory = gemstone_price.FullDescription.split('<!-- Cutting Factory  -->')[1].split('<!-- Cutting Factory end -->')[0];
         $('#tab-4 .box-wrap').append(cutfactory);
         }
          if(gemstone_price.FullDescription.split('<!-- our Process -->')[1] != undefined){
          var ourprocess =  gemstone_price.FullDescription.split('<!-- our Process -->')[1].split('<div class="box-wrap">')[1].split('<!-- our Process end -->')[0].replaceAll("</div>",'').split('<div class="box">')
            $(ourprocess).each(function(e){
             if($(e).length >0){
             $('#tab-2 .box-wrap').append(`<div class="box">${this}</div>`)
             } 
            })
          }
        }
        }
       $('.complete_gemstone_order_tabs .creativity_cost .count').attr('data-count',creativity_cost);
       $('.complete_gemstone_order_tabs .components_cost .count').attr('data-count',component_cost);
       $('.complete_gemstone_order_tabs .crafting_cost .count').attr('data-count',crafting_cost);
       $('.complete_gemstone_order_tabs .packaging_cost .count').attr('data-count',packaging_cost);
       $('.complete_gemstone_order_tabs .duties_freight .count').attr('data-count',duties_cost);
       $('.complete_gemstone_order_tabs .credit_card .count').attr('data-count',credit_price);
       $('.complete_gemstone_order_tabs .main_total_price .count').attr('data-count',total_price);
       $('.complete_gemstone_order_tabs .left-side-sct .main_price').text(total_sell_price);
       $('.complete_gemstone_order_tabs .right-side-sct .main_price').text(retail_cost);
       var counted = 0;
    if(!isNaN(credit_price) && !isNaN(component_cost) && !isNaN(total_price) && !isNaN(crafting_cost)){
      $('a#pricing_tab').show();
      $('div#tab-1').show();
      }else{
      $('#sourcing_ultra').trigger('click');
      }
      $('.count').each(function() {
      var $this = $(this),
      countTo = $this.attr('data-count');
      $({
      countNum: $this.text()
      }).animate({
        countNum: countTo
      },
      {
        duration: 2000,
        easing: 'swing',
        step: function() {
          $this.text(parseFloat(this.countNum).toFixed(2));
           $('.cstm-varaint-specific-jtpl').show();
        },
        complete: function() {
          $this.text(parseFloat(this.countNum).toFixed(2));
         $('.cstm-varaint-specific-jtpl').show();
        }
      });
      });
      
      if(isNaN(credit_price) || isNaN(component_cost) || isNaN(crafting_cost) && isNaN(data_component_per_val) && isNaN(data_crafting_per_val) && isNaN(data_packging_per_val)){
       $('#sourcing_ultra ,#tab-2').hide();
        $('#manf_tab').trigger('click');
        
      }
      counted = 1;
      }else{
       $('.complete_gemstone_order_tabs').hide();
      }
      }
    function get_gemstone_value(){
    return new Promise((resolve2) => {
    var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
    if(wizardInfo_gemstone != null){
    if(wizardInfo_gemstone.gemstone_vendorname != null && wizardInfo_gemstone.gemstone_vendorname != '' ){
    fetch(window.API_URL+`diamonds/vendorPage/singlevendorShow/${wizardInfo_gemstone.gemstone_vendorname}`, {
      method: 'GET',
      headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
      }).then(res => res.json())
      .then(response => {
         resolve2(response);
      });
    }else{
    resolve2('Not Found');
    }
    }
    })
    }
function get_gemstone_prices(){
return new Promise((resolve3) => {
var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
if(wizardInfo_gemstone != null){
if(wizardInfo_gemstone.gemstone_id != null && wizardInfo_gemstone.gemstone_id != '' ){
 fetch(window.API_URL+`diamonds/singleGemstone/${wizardInfo_gemstone.gemstone_id}`, {
        method: 'GET',
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json())
        .then(response => {
         resolve3(response);
        });
}else{
   resolve3('Not Found');
}
}
})
}
function getProductdata (handle){
return new Promise((resolve1) => {
 $.ajax({
    url: `https://my-solitaire.myshopify.com/products/${handle}?view=inventory`,
    type: 'GET',
    success: function(res) {
      resolve1(res);
    }
});
})
}
 var wizardInfo_gemstone = JSON.parse(localStorage.getItem("wizardInfo_gemstone"));
   if(wizardInfo_gemstone != null || wizardInfo_gemstone != undefined){
    var handle = wizardInfo_gemstone.setting_product_handle;
    var purpose= 'get_date'
    getProductImage(handle,purpose)
    }
    
function getProductImage(handle,purpose,gemstone_data,img_url,p_id,new_360_url,new_url) {
 
var product_id = p_id;
var custom_text_360 = localStorage.getItem('custom_text');
var custom_sku_360 = localStorage.getItem('custom_sku');  
  var purpose = purpose;
 
  $.ajax({
    url: `https://my-solitaire.myshopify.com/products/${handle}?view=dyor-setting&variant=${wizardInfo_gemstone.setting_variant_id}`,
    type: 'GET',
    success: function(res) {
     var wizardInfo_gemstone = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
      if(purpose == 'get_carat_val'){
      var product_carat =  parseFloat($(res).find('.product.product--stacked').attr('data-carat-size'));
      var stone_carat =   parseFloat(1);
      var total_carat_size = product_carat+stone_carat;
      
      }
       if(purpose == 'get_date'){
         let qntymore = $(res).find('.get_attr_main').attr('data-quantity_more');
          let qntyless = $(res).find('.get_attr_main').attr('data-quantity_less');
          let inventory_qty = $(res).find('.get_attr_main').attr('data-inventory_qty');
          let vprice = $(res).find('.get_attr_main').attr('data-vprice')
    
         calcDeliveryDate(inventory_qty,qntymore,qntyless,vprice);
          var p_url = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-url');
          var p_id = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+wizardInfo_gemstone.setting_variant_id+'"]').attr('data-pdid');
          var v_id = wizardInfo_gemstone.setting_variant_id;
         $('.swym-add-to-wishlist-view-product').attr({"data-product-id":p_id,"data-variant-id":v_id,"data-product-url":p_url}).addClass(`product_${p_id}`);
         document.dispatchEvent(new  CustomEvent("swym:completeRing-loaded"));
       }
       if(purpose == 'get_img'){
         
         var count =0;
        var no_img = parseInt($(res).find('.product__media-list li').length)-1;

       
        $(res).find('.product__media-list li').each(function(index,ele){
            if($(this).find('deferred-media').length >0){
              count= count+1;
               var aria_label =$(this).find('deferred-media video').attr('aria-label');
              var video_src =  $(this).find('deferred-media video source').attr('src');
                var poster_img = $(this).find('deferred-media video img').attr('src');
             $(`#grid-img-diamond #diamond-img${index+3},div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src=${video_src}><source src=${video_src} type="video/mp4"><img src='${poster_img}'></video>`)
             }else{
            var Img_src = $(this).find('.product__modal-opener .product__media img').attr('src');
                if(Img_src != undefined){
               if(index == 0){
               count= count+1;
                 wizardInfo_gemstone.setting_image_url = Img_src
              localStorage.setItem('wizardInfo_gemstone',JSON.stringify(wizardInfo_gemstone));
               $(`#grid-img-diamond #diamond-img1 ,div#carouselExampleIndicators .carousel-inner .diamond-img1`).html(`<img src=${Img_src} alt="">`);
               }else if(index >= 1){
                count= count+1;
                $(`#grid-img-diamond #diamond-img${index+3} ,div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<img src=${Img_src} alt="">`);
              }
             }
            }
        }); 
          myVar = setInterval( informUser, 100);
              function informUser(){
                if(count == no_img){
                  $('.carousel-inner .product-diamond-images').each(function(){
                  if ($(this).is(':empty')) {
                     $(this).remove(); 
                  }
                  })
                  $('.carousel .carousel-inner').slick({dots:true,arrows:true})
                  clearInterval(myVar);
                }
              }
       } 
       if(purpose == 'get_aws_img'){

    
          var count1 =0;
        var no_img = parseInt($(res).find('.product__media-list li.media_replace').length);
   
        $(res).find('.product__media-list li.media_replace').each(function(index,ele){
       
            if($(this).find('deferred-media').length >0){
               var Img_src = `${img_url}-${index+1}.jpg`;
              
                var metal_name = wizardInfo_gemstone.setting_selected_metal.toLowerCase().replace(/ /g,"-");
                var gemstone_name = gemstone_data.Title.replace(/\s+/g, '-').replaceAll('.', '-').toLowerCase();
                var shape = gemstone_data.Shape.toLowerCase();
                if($(res).find(`.gemstone_main_container[data-gemstone="${gemstone_name}"][data-metal="${metal_name}"] span.gemstone_images.images-${count1+1}`).length == 0 ){
                count1= count1+1;
                }
              var aria_label =$(this).find('deferred-media video').attr('aria-label');
              var video_src =  $(this).find('deferred-media video source').attr('src');
              var poster_img = $(this).find('deferred-media video img').attr('src');
              if( p_id == 7431068811400){
                 var video_url = `${img_url}_${index+1}.mp4`;
                $(`#grid-img-diamond #diamond-img${index+3},div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src='${video_url}'><source src='${video_url}' type="video/mp4"><img src=''></video>`)
               }else{
                var media_name_video = `https://dsv7iunirnrax.cloudfront.net/360/${new_360_url}${index+1}/frame01.png`; 
                checkImageExists(media_name_video, function(exists) {
                    if($(res).find(`.gemstone_main_container[data-gemstone="${gemstone_name}"][data-metal="${metal_name}"][data-video="true"]`).length > 0 ){
                      count1= count1+1;
                    var hanndle_url = `_${gemstone_name.replaceAll('-', '_')}_${metal_name.replaceAll('-', '_')}_${shape}`;
                      if($(res).find(`.gemstone_main_container[data-gemstone="${gemstone_name}"][data-metal="${metal_name}"][data-video="true"]`).attr('data-img-handle') != undefined || $(res).find(`.gemstone_main_container[data-gemstone="${gemstone_name}"][data-metal="${metal_name}"][data-video="true"]`).attr('data-img-handle') != ''){
                      var _360_url = `https://dsv7iunirnrax.cloudfront.net/360_gemstones/${hanndle_url}/frame-${$(res).find(`.gemstone_main_container[data-gemstone="${gemstone_name}"][data-metal="${metal_name}"][data-video="true"]`).attr('data-img-handle')}-01.png`
                       }else{
                      var _360_url = `https://dsv7iunirnrax.cloudfront.net/360_gemstones/${hanndle_url}/frame01.png`
                       } 
                         let _360_container = `<div class="preview col">
                          <div class="app-figure" id="zoom-fig">
                          <a id="spin-${index+1}" class="Magic360"  data-options="autospin: infinite; autospin-speed:12000, autospin-stop: hover; rows: 1;columns: 75;magnify: false;"
                           href="${_360_url}"
                           ><img src="${_360_url}"></a>
                         </div>
                       </div>`
                      let _360_container_mob = `<div class="preview col">
                      <div class="app-figure" id="zoom-fig">
                      <a id="spin-mob-${index+1}" class="Magic360"  data-options="autospin: infinite; autospin-speed:3600, autospin-stop: hover; rows: 1;columns: 75;magnify: false;"
                       href="${_360_url}"
                       ><img src="${_360_url}"></a>
                     </div>
                   </div>`
                      $(`#grid-img-diamond #diamond-img${index+3}`).html(`<div class="carat_shape_size"> ${_360_container}
                      <svg class="ctsm-360" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 65.79" style="enable-background:new 0 0 122.88 65.79" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M13.37,31.32c-22.23,12.2,37.65,19.61,51.14,19.49v-7.44l11.21,11.2L64.51,65.79v-6.97 C37.4,59.85-26.41,42.4,11.97,27.92c0.36,1.13,0.8,2.2,1.3,3.2L13.37,31.32L13.37,31.32z M108.36,8.31c0-2.61,0.47-4.44,1.41-5.48 c0.94-1.04,2.37-1.56,4.3-1.56c0.92,0,1.69,0.12,2.28,0.34c0.59,0.23,1.08,0.52,1.45,0.89c0.38,0.36,0.67,0.75,0.89,1.15 c0.22,0.4,0.39,0.87,0.52,1.41c0.26,1.02,0.38,2.09,0.38,3.21c0,2.49-0.42,4.32-1.27,5.47c-0.84,1.15-2.29,1.73-4.36,1.73 c-1.15,0-2.09-0.19-2.8-0.55c-0.71-0.37-1.3-0.91-1.75-1.62c-0.33-0.51-0.59-1.2-0.77-2.07C108.45,10.34,108.36,9.38,108.36,8.31 L108.36,8.31z M26.47,10.49l-9-1.6c0.75-2.86,2.18-5.06,4.31-6.59C23.9,0.77,26.91,0,30.8,0c4.47,0,7.69,0.83,9.69,2.5 c1.99,1.67,2.98,3.77,2.98,6.29c0,1.48-0.41,2.82-1.21,4.01c-0.81,1.2-2.02,2.25-3.65,3.15c1.32,0.33,2.34,0.71,3.03,1.15 c1.14,0.7,2.02,1.63,2.65,2.77c0.63,1.15,0.95,2.51,0.95,4.1c0,2-0.52,3.91-1.56,5.75c-1.05,1.83-2.55,3.24-4.51,4.23 c-1.96,0.99-4.54,1.48-7.74,1.48c-3.11,0-5.57-0.37-7.36-1.1c-1.8-0.73-3.28-1.8-4.44-3.22c-1.16-1.41-2.05-3.19-2.67-5.33 l9.53-1.27c0.38,1.92,0.95,3.26,1.74,4.01c0.78,0.74,1.78,1.12,3,1.12c1.27,0,2.33-0.47,3.18-1.4c0.85-0.93,1.27-2.18,1.27-3.74 c0-1.59-0.41-2.82-1.22-3.69c-0.81-0.87-1.92-1.31-3.32-1.31c-0.74,0-1.77,0.18-3.07,0.56l0.49-6.81c0.52,0.08,0.93,0.12,1.22,0.12 c1.23,0,2.26-0.4,3.08-1.19c0.82-0.79,1.24-1.72,1.24-2.81c0-1.05-0.31-1.88-0.93-2.49c-0.62-0.62-1.48-0.93-2.55-0.93 c-1.12,0-2.02,0.34-2.72,1.01C27.19,7.62,26.72,8.8,26.47,10.49L26.47,10.49z M75.15,8.27l-9.48,1.16 c-0.25-1.32-0.66-2.24-1.24-2.78c-0.59-0.54-1.31-0.81-2.16-0.81c-1.54,0-2.74,0.77-3.59,2.33c-0.62,1.13-1.09,3.52-1.38,7.19 c1.14-1.16,2.31-2.01,3.5-2.56c1.2-0.55,2.59-0.83,4.16-0.83c3.06,0,5.64,1.09,7.75,3.27c2.11,2.19,3.17,4.96,3.17,8.31 c0,2.26-0.53,4.32-1.6,6.2c-1.07,1.87-2.55,3.29-4.44,4.25c-1.9,0.96-4.27,1.44-7.13,1.44c-3.43,0-6.18-0.58-8.25-1.76 c-2.07-1.17-3.73-3.03-4.97-5.59c-1.24-2.56-1.86-5.95-1.86-10.18c0-6.18,1.3-10.71,3.91-13.59C54.13,1.44,57.74,0,62.36,0 c2.73,0,4.88,0.31,6.46,0.94c1.58,0.63,2.9,1.56,3.94,2.76C73.81,4.92,74.61,6.44,75.15,8.27L75.15,8.27z M57.62,23.55 c0,1.86,0.47,3.31,1.4,4.36c0.94,1.05,2.08,1.58,3.44,1.58c1.25,0,2.3-0.48,3.14-1.43c0.84-0.95,1.26-2.37,1.26-4.26 c0-1.93-0.44-3.41-1.31-4.42c-0.88-1.01-1.96-1.52-3.26-1.52c-1.32,0-2.44,0.49-3.34,1.48C58.06,20.32,57.62,21.72,57.62,23.55 L57.62,23.55z M77.91,17.57c0-6.51,1.17-11.07,3.52-13.67C83.77,1.3,87.35,0,92.14,0c2.31,0,4.2,0.29,5.68,0.85 c1.48,0.57,2.69,1.31,3.62,2.22c0.94,0.91,1.68,1.87,2.21,2.87c0.54,1.01,0.97,2.18,1.3,3.52c0.64,2.55,0.96,5.22,0.96,8 c0,6.22-1.05,10.76-3.16,13.64c-2.1,2.88-5.72,4.32-10.87,4.32c-2.88,0-5.21-0.46-6.99-1.38c-1.78-0.92-3.23-2.27-4.37-4.05 c-0.82-1.26-1.47-2.98-1.93-5.17C78.14,22.64,77.91,20.22,77.91,17.57L77.91,17.57z M87.34,17.59c0,4.36,0.38,7.34,1.16,8.94 c0.77,1.6,1.89,2.39,3.36,2.39c0.97,0,1.8-0.34,2.51-1.01c0.71-0.68,1.23-1.76,1.56-3.22c0.34-1.47,0.5-3.75,0.5-6.85 c0-4.55-0.38-7.6-1.16-9.18c-0.77-1.56-1.93-2.35-3.47-2.35c-1.58,0-2.71,0.8-3.42,2.39C87.69,10.31,87.34,13.27,87.34,17.59 L87.34,17.59z M112.14,8.32c0,1.75,0.15,2.94,0.46,3.58c0.31,0.64,0.76,0.96,1.35,0.96c0.39,0,0.72-0.13,1.01-0.41 c0.28-0.27,0.49-0.7,0.63-1.29c0.13-0.59,0.2-1.5,0.2-2.74c0-1.82-0.15-3.05-0.46-3.68c-0.31-0.63-0.77-0.94-1.39-0.94 c-0.63,0-1.09,0.32-1.37,0.96C112.28,5.4,112.14,6.59,112.14,8.32L112.14,8.32z M109.3,30.23c10.56,5.37,8.04,12.99-10.66,17.62 c-5.3,1.31-11.29,2.5-17.86,2.99v6.05c7.31-0.51,14.11-2.19,20.06-3.63c28.12-6.81,27.14-18.97,9.36-25.83 C109.95,28.42,109.65,29.35,109.3,30.23L109.3,30.23z"></path></g></svg>
                      </p> </div>`)
                      $(`div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<div class="carat_shape_size"> ${_360_container_mob}
                      <svg class="ctsm-360" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 65.79" style="enable-background:new 0 0 122.88 65.79" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M13.37,31.32c-22.23,12.2,37.65,19.61,51.14,19.49v-7.44l11.21,11.2L64.51,65.79v-6.97 C37.4,59.85-26.41,42.4,11.97,27.92c0.36,1.13,0.8,2.2,1.3,3.2L13.37,31.32L13.37,31.32z M108.36,8.31c0-2.61,0.47-4.44,1.41-5.48 c0.94-1.04,2.37-1.56,4.3-1.56c0.92,0,1.69,0.12,2.28,0.34c0.59,0.23,1.08,0.52,1.45,0.89c0.38,0.36,0.67,0.75,0.89,1.15 c0.22,0.4,0.39,0.87,0.52,1.41c0.26,1.02,0.38,2.09,0.38,3.21c0,2.49-0.42,4.32-1.27,5.47c-0.84,1.15-2.29,1.73-4.36,1.73 c-1.15,0-2.09-0.19-2.8-0.55c-0.71-0.37-1.3-0.91-1.75-1.62c-0.33-0.51-0.59-1.2-0.77-2.07C108.45,10.34,108.36,9.38,108.36,8.31 L108.36,8.31z M26.47,10.49l-9-1.6c0.75-2.86,2.18-5.06,4.31-6.59C23.9,0.77,26.91,0,30.8,0c4.47,0,7.69,0.83,9.69,2.5 c1.99,1.67,2.98,3.77,2.98,6.29c0,1.48-0.41,2.82-1.21,4.01c-0.81,1.2-2.02,2.25-3.65,3.15c1.32,0.33,2.34,0.71,3.03,1.15 c1.14,0.7,2.02,1.63,2.65,2.77c0.63,1.15,0.95,2.51,0.95,4.1c0,2-0.52,3.91-1.56,5.75c-1.05,1.83-2.55,3.24-4.51,4.23 c-1.96,0.99-4.54,1.48-7.74,1.48c-3.11,0-5.57-0.37-7.36-1.1c-1.8-0.73-3.28-1.8-4.44-3.22c-1.16-1.41-2.05-3.19-2.67-5.33 l9.53-1.27c0.38,1.92,0.95,3.26,1.74,4.01c0.78,0.74,1.78,1.12,3,1.12c1.27,0,2.33-0.47,3.18-1.4c0.85-0.93,1.27-2.18,1.27-3.74 c0-1.59-0.41-2.82-1.22-3.69c-0.81-0.87-1.92-1.31-3.32-1.31c-0.74,0-1.77,0.18-3.07,0.56l0.49-6.81c0.52,0.08,0.93,0.12,1.22,0.12 c1.23,0,2.26-0.4,3.08-1.19c0.82-0.79,1.24-1.72,1.24-2.81c0-1.05-0.31-1.88-0.93-2.49c-0.62-0.62-1.48-0.93-2.55-0.93 c-1.12,0-2.02,0.34-2.72,1.01C27.19,7.62,26.72,8.8,26.47,10.49L26.47,10.49z M75.15,8.27l-9.48,1.16 c-0.25-1.32-0.66-2.24-1.24-2.78c-0.59-0.54-1.31-0.81-2.16-0.81c-1.54,0-2.74,0.77-3.59,2.33c-0.62,1.13-1.09,3.52-1.38,7.19 c1.14-1.16,2.31-2.01,3.5-2.56c1.2-0.55,2.59-0.83,4.16-0.83c3.06,0,5.64,1.09,7.75,3.27c2.11,2.19,3.17,4.96,3.17,8.31 c0,2.26-0.53,4.32-1.6,6.2c-1.07,1.87-2.55,3.29-4.44,4.25c-1.9,0.96-4.27,1.44-7.13,1.44c-3.43,0-6.18-0.58-8.25-1.76 c-2.07-1.17-3.73-3.03-4.97-5.59c-1.24-2.56-1.86-5.95-1.86-10.18c0-6.18,1.3-10.71,3.91-13.59C54.13,1.44,57.74,0,62.36,0 c2.73,0,4.88,0.31,6.46,0.94c1.58,0.63,2.9,1.56,3.94,2.76C73.81,4.92,74.61,6.44,75.15,8.27L75.15,8.27z M57.62,23.55 c0,1.86,0.47,3.31,1.4,4.36c0.94,1.05,2.08,1.58,3.44,1.58c1.25,0,2.3-0.48,3.14-1.43c0.84-0.95,1.26-2.37,1.26-4.26 c0-1.93-0.44-3.41-1.31-4.42c-0.88-1.01-1.96-1.52-3.26-1.52c-1.32,0-2.44,0.49-3.34,1.48C58.06,20.32,57.62,21.72,57.62,23.55 L57.62,23.55z M77.91,17.57c0-6.51,1.17-11.07,3.52-13.67C83.77,1.3,87.35,0,92.14,0c2.31,0,4.2,0.29,5.68,0.85 c1.48,0.57,2.69,1.31,3.62,2.22c0.94,0.91,1.68,1.87,2.21,2.87c0.54,1.01,0.97,2.18,1.3,3.52c0.64,2.55,0.96,5.22,0.96,8 c0,6.22-1.05,10.76-3.16,13.64c-2.1,2.88-5.72,4.32-10.87,4.32c-2.88,0-5.21-0.46-6.99-1.38c-1.78-0.92-3.23-2.27-4.37-4.05 c-0.82-1.26-1.47-2.98-1.93-5.17C78.14,22.64,77.91,20.22,77.91,17.57L77.91,17.57z M87.34,17.59c0,4.36,0.38,7.34,1.16,8.94 c0.77,1.6,1.89,2.39,3.36,2.39c0.97,0,1.8-0.34,2.51-1.01c0.71-0.68,1.23-1.76,1.56-3.22c0.34-1.47,0.5-3.75,0.5-6.85 c0-4.55-0.38-7.6-1.16-9.18c-0.77-1.56-1.93-2.35-3.47-2.35c-1.58,0-2.71,0.8-3.42,2.39C87.69,10.31,87.34,13.27,87.34,17.59 L87.34,17.59z M112.14,8.32c0,1.75,0.15,2.94,0.46,3.58c0.31,0.64,0.76,0.96,1.35,0.96c0.39,0,0.72-0.13,1.01-0.41 c0.28-0.27,0.49-0.7,0.63-1.29c0.13-0.59,0.2-1.5,0.2-2.74c0-1.82-0.15-3.05-0.46-3.68c-0.31-0.63-0.77-0.94-1.39-0.94 c-0.63,0-1.09,0.32-1.37,0.96C112.28,5.4,112.14,6.59,112.14,8.32L112.14,8.32z M109.3,30.23c10.56,5.37,8.04,12.99-10.66,17.62 c-5.3,1.31-11.29,2.5-17.86,2.99v6.05c7.31-0.51,14.11-2.19,20.06-3.63c28.12-6.81,27.14-18.97,9.36-25.83 C109.95,28.42,109.65,29.35,109.3,30.23L109.3,30.23z"></path></g></svg> 
                      </p> </div>`)
                          Magic360.start(`spin-${index+1}`);
                         Magic360.start(`spin-mob-${index+1}`); 
                    }else if (exists) {
                      count1= count1+1;
                        var purpose_video = 'get_aws_video'
                         _360_container = `<div class="preview col">
                      <div class="app-figure" id="zoom-fig">
                      <a id="spin-${index+1}" class="Magic360"  data-options="autospin: infinite; autospin-speed:3600, autospin-stop: hover; rows: 1;columns: 75;magnify: false;"
                       href="${media_name_video}"
                       ><img src="${media_name_video}"></a>
                     </div>
                   </div>`;
                       _360_container_mob = `<div class="preview col">
                      <div class="app-figure" id="zoom-fig">
                      <a id="spin-mob-${index+1}" class="Magic360"  data-options="autospin: infinite; autospin-speed:3600, autospin-stop: hover; rows: 1;columns: 75;magnify: false;"
                       href="${media_name_video}"
                       ><img src="${media_name_video}"></a>
                     </div>
                   </div>`;
                       $(`#grid-img-diamond #diamond-img${index+3}`).html(`<div class="carat_shape_size"> ${_360_container}
                      <svg class="ctsm-360" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 65.79" style="enable-background:new 0 0 122.88 65.79" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M13.37,31.32c-22.23,12.2,37.65,19.61,51.14,19.49v-7.44l11.21,11.2L64.51,65.79v-6.97 C37.4,59.85-26.41,42.4,11.97,27.92c0.36,1.13,0.8,2.2,1.3,3.2L13.37,31.32L13.37,31.32z M108.36,8.31c0-2.61,0.47-4.44,1.41-5.48 c0.94-1.04,2.37-1.56,4.3-1.56c0.92,0,1.69,0.12,2.28,0.34c0.59,0.23,1.08,0.52,1.45,0.89c0.38,0.36,0.67,0.75,0.89,1.15 c0.22,0.4,0.39,0.87,0.52,1.41c0.26,1.02,0.38,2.09,0.38,3.21c0,2.49-0.42,4.32-1.27,5.47c-0.84,1.15-2.29,1.73-4.36,1.73 c-1.15,0-2.09-0.19-2.8-0.55c-0.71-0.37-1.3-0.91-1.75-1.62c-0.33-0.51-0.59-1.2-0.77-2.07C108.45,10.34,108.36,9.38,108.36,8.31 L108.36,8.31z M26.47,10.49l-9-1.6c0.75-2.86,2.18-5.06,4.31-6.59C23.9,0.77,26.91,0,30.8,0c4.47,0,7.69,0.83,9.69,2.5 c1.99,1.67,2.98,3.77,2.98,6.29c0,1.48-0.41,2.82-1.21,4.01c-0.81,1.2-2.02,2.25-3.65,3.15c1.32,0.33,2.34,0.71,3.03,1.15 c1.14,0.7,2.02,1.63,2.65,2.77c0.63,1.15,0.95,2.51,0.95,4.1c0,2-0.52,3.91-1.56,5.75c-1.05,1.83-2.55,3.24-4.51,4.23 c-1.96,0.99-4.54,1.48-7.74,1.48c-3.11,0-5.57-0.37-7.36-1.1c-1.8-0.73-3.28-1.8-4.44-3.22c-1.16-1.41-2.05-3.19-2.67-5.33 l9.53-1.27c0.38,1.92,0.95,3.26,1.74,4.01c0.78,0.74,1.78,1.12,3,1.12c1.27,0,2.33-0.47,3.18-1.4c0.85-0.93,1.27-2.18,1.27-3.74 c0-1.59-0.41-2.82-1.22-3.69c-0.81-0.87-1.92-1.31-3.32-1.31c-0.74,0-1.77,0.18-3.07,0.56l0.49-6.81c0.52,0.08,0.93,0.12,1.22,0.12 c1.23,0,2.26-0.4,3.08-1.19c0.82-0.79,1.24-1.72,1.24-2.81c0-1.05-0.31-1.88-0.93-2.49c-0.62-0.62-1.48-0.93-2.55-0.93 c-1.12,0-2.02,0.34-2.72,1.01C27.19,7.62,26.72,8.8,26.47,10.49L26.47,10.49z M75.15,8.27l-9.48,1.16 c-0.25-1.32-0.66-2.24-1.24-2.78c-0.59-0.54-1.31-0.81-2.16-0.81c-1.54,0-2.74,0.77-3.59,2.33c-0.62,1.13-1.09,3.52-1.38,7.19 c1.14-1.16,2.31-2.01,3.5-2.56c1.2-0.55,2.59-0.83,4.16-0.83c3.06,0,5.64,1.09,7.75,3.27c2.11,2.19,3.17,4.96,3.17,8.31 c0,2.26-0.53,4.32-1.6,6.2c-1.07,1.87-2.55,3.29-4.44,4.25c-1.9,0.96-4.27,1.44-7.13,1.44c-3.43,0-6.18-0.58-8.25-1.76 c-2.07-1.17-3.73-3.03-4.97-5.59c-1.24-2.56-1.86-5.95-1.86-10.18c0-6.18,1.3-10.71,3.91-13.59C54.13,1.44,57.74,0,62.36,0 c2.73,0,4.88,0.31,6.46,0.94c1.58,0.63,2.9,1.56,3.94,2.76C73.81,4.92,74.61,6.44,75.15,8.27L75.15,8.27z M57.62,23.55 c0,1.86,0.47,3.31,1.4,4.36c0.94,1.05,2.08,1.58,3.44,1.58c1.25,0,2.3-0.48,3.14-1.43c0.84-0.95,1.26-2.37,1.26-4.26 c0-1.93-0.44-3.41-1.31-4.42c-0.88-1.01-1.96-1.52-3.26-1.52c-1.32,0-2.44,0.49-3.34,1.48C58.06,20.32,57.62,21.72,57.62,23.55 L57.62,23.55z M77.91,17.57c0-6.51,1.17-11.07,3.52-13.67C83.77,1.3,87.35,0,92.14,0c2.31,0,4.2,0.29,5.68,0.85 c1.48,0.57,2.69,1.31,3.62,2.22c0.94,0.91,1.68,1.87,2.21,2.87c0.54,1.01,0.97,2.18,1.3,3.52c0.64,2.55,0.96,5.22,0.96,8 c0,6.22-1.05,10.76-3.16,13.64c-2.1,2.88-5.72,4.32-10.87,4.32c-2.88,0-5.21-0.46-6.99-1.38c-1.78-0.92-3.23-2.27-4.37-4.05 c-0.82-1.26-1.47-2.98-1.93-5.17C78.14,22.64,77.91,20.22,77.91,17.57L77.91,17.57z M87.34,17.59c0,4.36,0.38,7.34,1.16,8.94 c0.77,1.6,1.89,2.39,3.36,2.39c0.97,0,1.8-0.34,2.51-1.01c0.71-0.68,1.23-1.76,1.56-3.22c0.34-1.47,0.5-3.75,0.5-6.85 c0-4.55-0.38-7.6-1.16-9.18c-0.77-1.56-1.93-2.35-3.47-2.35c-1.58,0-2.71,0.8-3.42,2.39C87.69,10.31,87.34,13.27,87.34,17.59 L87.34,17.59z M112.14,8.32c0,1.75,0.15,2.94,0.46,3.58c0.31,0.64,0.76,0.96,1.35,0.96c0.39,0,0.72-0.13,1.01-0.41 c0.28-0.27,0.49-0.7,0.63-1.29c0.13-0.59,0.2-1.5,0.2-2.74c0-1.82-0.15-3.05-0.46-3.68c-0.31-0.63-0.77-0.94-1.39-0.94 c-0.63,0-1.09,0.32-1.37,0.96C112.28,5.4,112.14,6.59,112.14,8.32L112.14,8.32z M109.3,30.23c10.56,5.37,8.04,12.99-10.66,17.62 c-5.3,1.31-11.29,2.5-17.86,2.99v6.05c7.31-0.51,14.11-2.19,20.06-3.63c28.12-6.81,27.14-18.97,9.36-25.83 C109.95,28.42,109.65,29.35,109.3,30.23L109.3,30.23z"></path></g></svg>
                      </p> </div>`)
                      $(`div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<div class="carat_shape_size"> ${_360_container_mob}
                      <svg class="ctsm-360" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 65.79" style="enable-background:new 0 0 122.88 65.79" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M13.37,31.32c-22.23,12.2,37.65,19.61,51.14,19.49v-7.44l11.21,11.2L64.51,65.79v-6.97 C37.4,59.85-26.41,42.4,11.97,27.92c0.36,1.13,0.8,2.2,1.3,3.2L13.37,31.32L13.37,31.32z M108.36,8.31c0-2.61,0.47-4.44,1.41-5.48 c0.94-1.04,2.37-1.56,4.3-1.56c0.92,0,1.69,0.12,2.28,0.34c0.59,0.23,1.08,0.52,1.45,0.89c0.38,0.36,0.67,0.75,0.89,1.15 c0.22,0.4,0.39,0.87,0.52,1.41c0.26,1.02,0.38,2.09,0.38,3.21c0,2.49-0.42,4.32-1.27,5.47c-0.84,1.15-2.29,1.73-4.36,1.73 c-1.15,0-2.09-0.19-2.8-0.55c-0.71-0.37-1.3-0.91-1.75-1.62c-0.33-0.51-0.59-1.2-0.77-2.07C108.45,10.34,108.36,9.38,108.36,8.31 L108.36,8.31z M26.47,10.49l-9-1.6c0.75-2.86,2.18-5.06,4.31-6.59C23.9,0.77,26.91,0,30.8,0c4.47,0,7.69,0.83,9.69,2.5 c1.99,1.67,2.98,3.77,2.98,6.29c0,1.48-0.41,2.82-1.21,4.01c-0.81,1.2-2.02,2.25-3.65,3.15c1.32,0.33,2.34,0.71,3.03,1.15 c1.14,0.7,2.02,1.63,2.65,2.77c0.63,1.15,0.95,2.51,0.95,4.1c0,2-0.52,3.91-1.56,5.75c-1.05,1.83-2.55,3.24-4.51,4.23 c-1.96,0.99-4.54,1.48-7.74,1.48c-3.11,0-5.57-0.37-7.36-1.1c-1.8-0.73-3.28-1.8-4.44-3.22c-1.16-1.41-2.05-3.19-2.67-5.33 l9.53-1.27c0.38,1.92,0.95,3.26,1.74,4.01c0.78,0.74,1.78,1.12,3,1.12c1.27,0,2.33-0.47,3.18-1.4c0.85-0.93,1.27-2.18,1.27-3.74 c0-1.59-0.41-2.82-1.22-3.69c-0.81-0.87-1.92-1.31-3.32-1.31c-0.74,0-1.77,0.18-3.07,0.56l0.49-6.81c0.52,0.08,0.93,0.12,1.22,0.12 c1.23,0,2.26-0.4,3.08-1.19c0.82-0.79,1.24-1.72,1.24-2.81c0-1.05-0.31-1.88-0.93-2.49c-0.62-0.62-1.48-0.93-2.55-0.93 c-1.12,0-2.02,0.34-2.72,1.01C27.19,7.62,26.72,8.8,26.47,10.49L26.47,10.49z M75.15,8.27l-9.48,1.16 c-0.25-1.32-0.66-2.24-1.24-2.78c-0.59-0.54-1.31-0.81-2.16-0.81c-1.54,0-2.74,0.77-3.59,2.33c-0.62,1.13-1.09,3.52-1.38,7.19 c1.14-1.16,2.31-2.01,3.5-2.56c1.2-0.55,2.59-0.83,4.16-0.83c3.06,0,5.64,1.09,7.75,3.27c2.11,2.19,3.17,4.96,3.17,8.31 c0,2.26-0.53,4.32-1.6,6.2c-1.07,1.87-2.55,3.29-4.44,4.25c-1.9,0.96-4.27,1.44-7.13,1.44c-3.43,0-6.18-0.58-8.25-1.76 c-2.07-1.17-3.73-3.03-4.97-5.59c-1.24-2.56-1.86-5.95-1.86-10.18c0-6.18,1.3-10.71,3.91-13.59C54.13,1.44,57.74,0,62.36,0 c2.73,0,4.88,0.31,6.46,0.94c1.58,0.63,2.9,1.56,3.94,2.76C73.81,4.92,74.61,6.44,75.15,8.27L75.15,8.27z M57.62,23.55 c0,1.86,0.47,3.31,1.4,4.36c0.94,1.05,2.08,1.58,3.44,1.58c1.25,0,2.3-0.48,3.14-1.43c0.84-0.95,1.26-2.37,1.26-4.26 c0-1.93-0.44-3.41-1.31-4.42c-0.88-1.01-1.96-1.52-3.26-1.52c-1.32,0-2.44,0.49-3.34,1.48C58.06,20.32,57.62,21.72,57.62,23.55 L57.62,23.55z M77.91,17.57c0-6.51,1.17-11.07,3.52-13.67C83.77,1.3,87.35,0,92.14,0c2.31,0,4.2,0.29,5.68,0.85 c1.48,0.57,2.69,1.31,3.62,2.22c0.94,0.91,1.68,1.87,2.21,2.87c0.54,1.01,0.97,2.18,1.3,3.52c0.64,2.55,0.96,5.22,0.96,8 c0,6.22-1.05,10.76-3.16,13.64c-2.1,2.88-5.72,4.32-10.87,4.32c-2.88,0-5.21-0.46-6.99-1.38c-1.78-0.92-3.23-2.27-4.37-4.05 c-0.82-1.26-1.47-2.98-1.93-5.17C78.14,22.64,77.91,20.22,77.91,17.57L77.91,17.57z M87.34,17.59c0,4.36,0.38,7.34,1.16,8.94 c0.77,1.6,1.89,2.39,3.36,2.39c0.97,0,1.8-0.34,2.51-1.01c0.71-0.68,1.23-1.76,1.56-3.22c0.34-1.47,0.5-3.75,0.5-6.85 c0-4.55-0.38-7.6-1.16-9.18c-0.77-1.56-1.93-2.35-3.47-2.35c-1.58,0-2.71,0.8-3.42,2.39C87.69,10.31,87.34,13.27,87.34,17.59 L87.34,17.59z M112.14,8.32c0,1.75,0.15,2.94,0.46,3.58c0.31,0.64,0.76,0.96,1.35,0.96c0.39,0,0.72-0.13,1.01-0.41 c0.28-0.27,0.49-0.7,0.63-1.29c0.13-0.59,0.2-1.5,0.2-2.74c0-1.82-0.15-3.05-0.46-3.68c-0.31-0.63-0.77-0.94-1.39-0.94 c-0.63,0-1.09,0.32-1.37,0.96C112.28,5.4,112.14,6.59,112.14,8.32L112.14,8.32z M109.3,30.23c10.56,5.37,8.04,12.99-10.66,17.62 c-5.3,1.31-11.29,2.5-17.86,2.99v6.05c7.31-0.51,14.11-2.19,20.06-3.63c28.12-6.81,27.14-18.97,9.36-25.83 C109.95,28.42,109.65,29.35,109.3,30.23L109.3,30.23z"></path></g></svg> 
                      </p> </div>`)
                       Magic360.start(`spin-${index+1}`, -1);
                        Magic360.start(`spin-mob-${index+1}`, -1);  
                       }else{
                      count1= count1+1;
                       $(`#grid-img-diamond #diamond-img${index+3},div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src=${video_src}><source src=${video_src} type="video/mp4"><img src='${poster_img}'></video>`)
                           
                    }
                 })
                }
              }else{
               var Img_src = `${img_url}-${index+1}.jpg`;
               var new_url_src = `${new_url}-${index+1}.jpg`;
               var metal_name = wizardInfo_gemstone.setting_selected_metal.toLowerCase().replace(/[^a-z0-9]+/g, '').replace(/-$/, '').replace(/^-/, '');
               var gemstone_type = wizardInfo_gemstone.gemstone_type.toLowerCase().replace(/ /g,"-");
               var gemstone_shape = wizardInfo_gemstone.gemstone_shape.toLowerCase().replace(/ /g,"-");
               var gemstone_id = wizardInfo_gemstone.gemstone_id.toLowerCase().replace(/ /g,"-");
               var gemstone_name = gemstone_data.Title.replace(/\s+/g, '-').replaceAll('.', '-').toLowerCase();
              
              if(index == 0){
                 count1= count1+1;
                 wizardInfo_gemstone.setting_image_url = Img_src
              localStorage.setItem('wizardInfo_gemstone',JSON.stringify(wizardInfo_gemstone));
                 $(`#grid-img-diamond #diamond-img1 ,div#carouselExampleIndicators .carousel-inner .diamond-img1`).html(`<img src=${Img_src} alt="">`);
                 
              // }else if(index >0){
              //    count1= count1+1;
              //    $(`#grid-img-diamond #diamond-img${index+3} ,div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<img src=${new_url_src} alt="">`);
              // }
              }
            }
        });
          myVar = setInterval( informUser, 100);
              function informUser(){
                if(count1 == no_img){
                  $('.carousel-inner .product-diamond-images').each(function(){
                  if ($(this).is(':empty')) {
                     $(this).remove(); 
                  }
                  })
                  $('.carousel .carousel-inner').slick({dots:true,arrows:true})
                  clearInterval(myVar);
                }
              }
       }

    }
});

}
function calcDeliveryDate(delivery_Date,qntymore,qntyless,price){ 
              var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
              var stone_deliver = 0;
                if(wizardInfo != undefined && wizardInfo != null){
                if(wizardInfo.gemstone_deliver_date != undefined && wizardInfo.gemstone_deliver_date != null){
                stone_deliver = parseInt(wizardInfo.gemstone_deliver_date)
                }
                }
              var skipDates = $('.gemstone_complete').attr('data-exclued-date');
              var qnty_more_data = parseInt($('.gemstone_complete').attr('data-qty-more'));
              var qnty_less_data =  parseInt($('.gemstone_complete').attr('data-qty-less'));
             console.log(skipDates)
             
              if(qntymore == undefined || qntymore == 0){
              var qnty_more_data = qnty_more_data;
              } else{
              var qnty_more_data = qntymore;  
              }  
              if(qntyless == undefined || qntyless == 0){
              var qnty_less_data = qnty_less_data;
              } else{
              var qnty_less_data = qntyless;  
              } 
   console.log(delivery_Date);
              if(delivery_Date >= 1){
               
              if(qnty_more_data == 0){
              qnty_more_data_updated = qnty_more_data + 1;
              } else{
              qnty_more_data_updated = qnty_more_data;
              }          
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
              ];
              let today = new Date();
              const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
              let hh = new Date(pstDate).getHours();
              if(hh > 15){
              var dd = today.getDate() + 1 ; 
              }  else{
              var dd = today.getDate();
              }
              if(stone_deliver > 0){
                dd = dd + stone_deliver
                if(dd>31){
                  dd = 31
                }
              }
                console.log(dd);
              let mm = today.getMonth() + 1;
              let yyyy = today.getFullYear();
              var startDate = yyyy + '/' + mm + '/' + dd;
              startDate = new Date(startDate);
              var endDate = "";
              var noOfDaysToAdd = qnty_more_data_updated;
              var count = 0;
              while(count < noOfDaysToAdd){
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
              count++;
              }
              }
              const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
              var country_loc = localStorage.getItem("countryus");
              
              if(country_loc == "yes") {
              if(price < 250 ){  
              var newDate =  new Date(endDate.getTime() + (3 * 86400000));
              var newDate2 = new Date(endDate.getTime() + (6 * 86400000));
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1;
              var newddrange = newDate2.getDate();
              } else{
              var newdd = newDate.getDate();
              var newddrange = newDate2.getDate();
              }
              var newmm = newDate.getMonth() + 1;
              
              if(qnty_less_data == 0){
              var dayrange = weekday[newDate2.getDay()];
              var day = weekday[newDate.getDay() -1];
              } else{
              var dayrange = weekday[newDate2.getDay()];
              var day = weekday[newDate.getDay()];
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayrange+', '+monthNames[newDate2.getMonth()] + ' ' +newddrange;
              } else{
              console.log(skipDates);
              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1;
              
              } else{
              var newdd = newDate.getDate();
              }
              var newmm = newDate.getMonth() + 1;
              if(qnty_less_data == 0){
              var day = weekday[newDate.getDay() -1];
              } else{
              var day = weekday[newDate.getDay()];
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
              }
              } else{                   var newDate =  new Date(endDate.getTime());
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1; 
              } else{
              var newdd = newDate.getDate();  
              }
              if(qnty_less_data == 0){
              var day = weekday[newDate.getDay() -1];
              } else{
              var day = weekday[newDate.getDay()];
              } 
              var newmm = newDate.getMonth() + 1;
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
              }
              var text = document.createTextNode(finalDate).textContent;
              document.getElementById('est_delivery_date').innerHTML = text;    
              document.getElementById('delivery_date').value = text; 
              } else if(delivery_Date < 1){
              if(qnty_less_data == 0){
              qnty_less_data_updated = parseInt(qnty_less_data) + 1;
              } else{
              qnty_less_data_updated = qnty_less_data;
              }
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
              ];
              let today = new Date();
              const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
              let hh = new Date(pstDate).getHours();
              if(hh > 15){
              if(qnty_less_data == 0){
              var dd = today.getDate() + 1 ; 
              } else{
              var dd = today.getDate() + 2 ;  
              }
              }  else{
              if(qnty_less_data == 0){
              var dd = today.getDate(); 
              } else{
              var dd = today.getDate() + 1 ;  
              }
              }
                if(stone_deliver > 0){
                dd = dd + stone_deliver
                  if(dd>31){
                  dd = 31
                }
              }
                console.log(dd);
              let mm = today.getMonth() + 1;
              let yyyy = today.getFullYear();
              var startDate = yyyy + '/' + mm + '/' + dd;
              startDate = new Date(startDate);
              var startDateRange = yyyy + '/' + mm + '/' + dd;
              startDateRange = new Date(startDateRange);
              var startDateOUtUs = yyyy + '/' + mm + '/' + dd;
              startDateOUtUs = new Date(startDateOUtUs); 
              var endDate = "";
              var endDateoutus = "";
              var endDateRange = "";
              var country_loc = localStorage.getItem("countryus");
              if(country_loc == 'yes'){
              if(price < 251 ){
              if(qnty_less_data == 0){
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
              } else{
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 3 ; 
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 6 ; 
              }  
              } else{
              if(qnty_less_data == 0){
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 1 ;
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 4 ; 
              } else{
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ;
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
              }   
              }  
              } else{
              if(qnty_less_data == 0){
              var noOfDaysToAddoutusa = parseInt(qnty_less_data_updated) + 1;  
              } else{
              var noOfDaysToAddoutusa = qnty_less_data_updated; 
              }   
              }
              var countoutus = 0;
              while(countoutus < noOfDaysToAddoutusa ){
              endDateoutus = new Date(startDateOUtUs.setDate(startDateOUtUs.getDate() + 1)); 
                
              if (skipDates.includes(endDateoutus.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDateoutus.getDay() != 0 && endDateoutus.getDay() != 6 &&  !skipDates.includes(startDateOUtUs.toISOString().substring(0, 10))) {
              console.log(endDateoutus);
              countoutus++;
              }
              }
              var count = 0;
              while(count < noOfDaysToAdd ){
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
              count++;
              }
              }
              var count1 = 0;
              while(count1 < noOfDaysToAddrange ){
              endDateRange = new Date(startDateRange.setDate(startDateRange.getDate() + 1)); 
              if (skipDates.includes(endDateRange.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDateRange.getDay() != 0 && endDateRange.getDay() != 6 &&  !skipDates.includes(startDateRange.toISOString().substring(0, 10))) {
              count1++;
              }
              }
              const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]; 
              var country_loc = localStorage.getItem("countryus");
              if(country_loc == "yes") {
              var newDateRange =  new Date(endDateRange.getTime());
              var newDaten =  new Date(endDateRange.getTime() + (1 * 86400000));
              var skipDates = $('.gemstone_complete').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDateRange =  new Date(endDateRange.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDateRange.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDateRange =  new Date(endDateRange.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDateRange.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDateRange =  new Date(endDateRange.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDateRange.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDateRange =  new Date(endDateRange.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              
              var newDate =  new Date(endDate.getTime());
              var newDaten =  new Date(endDate.getTime() + (1 * 86400000));
              var skipDates = $('.gemstone_complete').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDate =  new Date(endDate.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDate.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDate.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDate =  new Date(endDate.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDate.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDate =  new Date(endDate.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              var newddRange = newDateRange.getDate();
              var newmmRange = newDateRange.getMonth() + 1;
              let dayRange = weekday[newDateRange.getDay()];
              var newdd = newDate.getDate();
              var newmm = newDate.getMonth() + 1;
              let day = weekday[newDate.getDay()];
              if(newdd == "1" || newdd == "21" || newdd == "31"){
              var dayt = newdd+'st';
              } else if(newdd == "2" || newdd == "22"){
               var dayt = newdd+'nd';
              } else if(newdd == "3" || newdd == "33"){
              var dayt = newdd+'rd';
              } else{
              var dayt = newdd+'th';
              }
              if(newddRange == "1" || newddRange == "21" || newddRange == "31"){
              var daytrange = newddRange+'st';
              } else if(newddRange == "2" || newddRange == "22"){
               var daytrange = newddRange+'nd';
              } else if(newddRange == "3" || newddRange == "33"){
              var daytrange = newddRange+'rd';
              } else{
              var daytrange = newddRange+'th';
              }
              if(price < 251 ){
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayRange+', '+monthNames[newDateRange.getMonth()] + ' ' +daytrange;
              } else{
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +dayt ;
              }  
              var text = document.createTextNode(finalDate);
              var text = document.createTextNode(finalDate).textContent;
                console.log(text)
              document.querySelector('#deliverydate').innerHTML = text;
              } else{
              var newDate =  new Date(endDateoutus.getTime());
              var newDaten =  new Date(endDateoutus.getTime() + (1 * 86400000));
              var skipDates = $('.gemstone_complete').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDate =  new Date(endDateoutus.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDateoutus.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDate =  new Date(endDateoutus.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDateoutus.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDate =  new Date(endDateoutus.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDateoutus.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDate =  new Date(endDateoutus.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              var newdd = newDate.getDate();
              var newmm = newDate.getMonth() + 1;
              let day = weekday[newDate.getDay()];
              if(newdd == "1" || newdd == "21" || newdd == "31"){
              var dayt = newdd+'st';
              } else if(newdd == "2" || newdd == "22"){
               var dayt = newdd+'nd';
              } else if(newdd == "3" || newdd == "33"){
              var dayt = newdd+'rd';
              } else{
              var dayt = newdd+'th';
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd ;
              }
              var endDateSpecial = $('.end_date_sp').text();
              var startDateSpecial = $('.start_date_sp').text();
              const date2 = new Date(endDateSpecial);
              const date1 = new Date(startDateSpecial);
              const date3 = new Date(newDate);
              const date4 = new Date(newDateRange);
              if(country_loc == "yes") {  
              if(price < 251 ){
              if (date4 > date1 && date4 <= date2) {
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'flex';
              document.getElementById('special_ocassion_id').value = '1';
              }
              } else{
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'none';
              document.getElementById('special_ocassion_id').value = '0'; 
              }
              }
              } else{
              if (date3 > date1 && date3 <= date2) {
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'flex';
              document.getElementById('special_ocassion_id').value = '1';
              }
              } else{
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'none';
              document.getElementById('special_ocassion_id').value = '0'; 
              }
              }
              }  
              }              
              var text = document.createTextNode(finalDate).textContent;
                console.log(text);
               document.querySelector('#deliverydate').innerHTML = text;
               } 
              }
async function loadInfoRing(){
    //allImage(); 
   
    let infoRing = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));    

    if (infoRing !=null || infoRing !=undefined) {
        var product_data = await getProductdata(wizardInfo.setting_product_handle);
        var gemstone_data = await getdiamond_img(wizardInfo.gemstone_id);
       let currentCurrency = Shopify.currency.active;
       let currentCurrencySymbol = $('body').attr('data-currency');
       let currentRate = window.Shopify.currency.rate;
       
        let productId = $(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('p_id');
        let variantSku = $(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('v_sku');
        // let diamondPrice = toNumberFormat(gemstone_data.Price2Total * currentRate);
        let rawPrice = gemstone_data.Price2Total.replace(/,/g, '');
        let numericPrice = parseFloat(rawPrice) * currentRate;
        let diamondPrice = Number(numericPrice.toFixed(2));
      
        let caratSetting= toNumberFormat(infoRing.setting_selected_side_carat_weight);
        let settingPrice= parseFloat($(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('p-without-m'))/100

        let totalPrice = parseFloat(diamondPrice) + parseFloat(settingPrice);

        let ring_band_product = JSON.parse(localStorage.getItem('ring_band_product'));
        if(ring_band_product != null && ring_band_product != undefined){
         settingPrice = toNumberFormat(ring_band_product.ring_product_total_price);

       
         totalPrice = parseFloat(infoRing.gemstone_price * currentRate) + parseFloat(ring_band_product.ring_product_total_price); 
        } 
        totalPrice= totalPrice.toFixed(2);     

        $('#total-price').text(currentCurrencySymbol+''+totalPrice);
        let totalCarat =infoRing.stone_carat + infoRing.setting_selected_side_carat_weight;
        totalCarat=toNumberFormat(totalCarat);   
       var color = '';
      if(gemstone_data.ColorHue != null && gemstone_data.ColorHue != '' && gemstone_data.ColorHue != undefined){
      var color = `<span class="dot">•</span> ${gemstone_data.ColorHue} Color`
      }
      
      if(gemstone_data.Shape != null && gemstone_data.Shape != ''){
      var gemstone_shape = `<span class="dot">•</span> ${gemstone_data.Shape} Shape`
       }
         document.getElementById('diamond-short-detail').innerHTML = `${gemstone_data.Title}`;
         document.getElementById('diamond_description').innerHTML = `${color} ${gemstone_shape}`;
         document.getElementById('diamond-price').innerHTML = currentCurrencySymbol+''+diamondPrice; 
         let allowedRingSizes = $(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('data-ring-sizes').split(',');
        // Let's create the options for the select
        let selectSize = document.getElementById('select-size');
        allowedRingSizes.forEach((size)=>{
            let option = document.createElement('option');
            option.value = size;
            option.innerHTML = size;
            selectSize.appendChild(option);
        });
        let caratString = caratSetting>0?` with ${caratSetting} carats of diamonds.`:'';
        document.getElementById('setting-short-detail').innerHTML = `${infoRing.setting_selected_metal} ${$(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('product-name')} ring ${caratString}`;
        document.getElementById('setting-price').innerHTML = currentCurrencySymbol+''+settingPrice;

        let extraTotalWeightString = caratSetting>0?' (includes center stone).':'.';

       // document.getElementById('deliverydate').innerHTML = `${infoRing.stone_delivery}`;
        $('#diamond-with-setting').text(`ADD TO CART | ${currentCurrencySymbol} ${totalPrice} `)

    }
}

loadInfoRing();
bindEvents();
order_detail();
function isV360(url){
    if(url.indexOf('360') > -1){
        return true;
    }
    else{
        return false;
    }
}
 function getdiamond_img(diamond_id){
   return new Promise((resolve) => {
   url = window.API_URL +`diamonds/singleGemstone/${diamond_id}`;
   let resp;
   fetch(url, {
        method: 'GET',        
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json()).then(async diamond => {
        resolve(diamond)
      
       //diamond.Certificate_Number
       if(diamond.VideoUrl.indexOf('mp4') > -1){
            gemstone_360(diamond);
            }
            if(diamond.Image1 != null ){
            gemstone_images(diamond);
            }
    })
   });  
}
function gemstone_images(response) {
  
     if(response.Image1 != null && response.Image1 !='-'){
            $('#grid-img-diamond #diamond-img3').html(`<img src="${response.Image1}" alt="">`);
            $('.carousel-inner div#diamond-img3').html(`<img src="${response.Image1}" alt="">`)
            }
  }
  function gemstone_360(response){
        let proster_img = `<img src="${response.Image1}" alt="gemstone_poster" id="_360_poster_image" class="poster_image">`
        let _360icon = `<span class="_360_icons gemstone"><img src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/360-view.svg?v=1712654633" class="_360_rotation" width=24></span>`
        let _360_container = `<div class="preview col" style="display:none">
        <div class="app-figure" id="zoom-fig">
        <a id="spin-1" class="Magic360"  data-options="autospin: infinite; autospin-stop: hover; spin: hover; rows: 1;columns: 72;magnify: false;"
         href="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${response.Stock}/frame01.png"
         ><img src="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${response.Stock}/frame01.png"></a>
       </div>
     </div>` 
    let _360_container_mob = `<div class="preview col" style="display:none">
        <div class="app-figure" id="zoom-fig">
        <a id="spin-mob-1" class="Magic360"  data-options="autospin: infinite; autospin-stop: hover; spin: hover; rows: 1;columns: 72;magnify: false;"
         href="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${response.Stock}/frame01.png"
         ><img src="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${response.Stock}/frame01.png"></a>
       </div>
     </div>`
     $('.diamond-pictures #diamond-img2').html(`<div class="_360_main_container inner">${proster_img}${_360_container}${_360icon}</div>`);
     $('.carousel-inner div#diamond-img2').html(`<div class="_360_main_container inner">${proster_img}${_360_container_mob}${_360icon}</div>`);
  }
$('#select-size').change(function(){
  $('#selected_value_error').hide();
})
function checkImageExists(imageUrl, callback) {
    var img = new Image();
    img.onload = function() {
        // The image loaded successfully
        callback(true);
    };
    img.onerror = function() {
        // The image could not be loaded
        callback(false);
    };
    img.src = imageUrl;
}
 $('.carousel-inner').on('afterChange', function(event, slick, currentSlide) {
    if ($(this).find('.product-diamond-images[data-slick-index="'+currentSlide+'"] .Magic360 canvas').length >0) {    
    $('.carousel-inner').addClass('videonextbtn'); 
    $('.carousel-inner').slick("slickSetOption", "accessibility", false);
    $('.carousel-inner').slick("slickSetOption", "draggable", false);
    $('.carousel-inner').slick("slickSetOption", "swipe", false);
    $('.carousel-inner').slick("slickSetOption", "touchMove", false);

  }else{
  $('.carousel-inner').removeClass('videonextbtn');
  $('.carousel-inner').slick("slickSetOption", "accessibility", true);
  $('.carousel-inner').slick("slickSetOption", "draggable", true);
  $('.carousel-inner').slick("slickSetOption", "swipe", true);
  $('.carousel-inner').slick("slickSetOption", "touchMove", true);
  
   }
  
     
});    
